import * as Sentry from '@sentry/react';

import { LOCATION_IS_JWPLAYER_COM, LOCATION_IS_LOCALHOST } from '/config/constants';

import { createLocalTransport as createDevEnvTransport } from './local-transport';

const REPLAY_ERROR_FILTER = ['MainAppError', 'PageError', 'SecurityError'];
const BASE_CONFIG: Sentry.BrowserOptions = {
  dsn: 'https://68d350685ff440ac86fa67794236ee7e@o122491.ingest.sentry.io/5435545',
  release: 'react-dashboard@' + import.meta.env.APP_DASHBOARD_VERSION,
  denyUrls: [
    // Facebook flakiness
    /graph\.facebook\.com/i,
    // Facebook blocked
    /connect\.facebook\.net\/en_US\/all\.js/i,
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
  ],

  // Handle errors to only log unexpected errors and increase these values in production
  sampleRate: 0.1,
  tracesSampleRate: 0.1,

  environment: import.meta.env.APP_JW_ENV,
  autoSessionTracking: false,
};

export const getSentryConfig = (): Sentry.BrowserOptions => {
  if (!LOCATION_IS_JWPLAYER_COM && LOCATION_IS_LOCALHOST) {
    return {
      ...BASE_CONFIG,
      sampleRate: 1,
      tracesSampleRate: 1,
      transport: createDevEnvTransport,
    };
  }

  switch (import.meta.env.APP_JW_ENV) {
    case 'dev':
      return {
        ...BASE_CONFIG,
        sampleRate: 1,
        tracesSampleRate: 1,
        transport: createDevEnvTransport,
      };
    case 'stg':
      return {
        ...BASE_CONFIG,
      };
    case 'prd':
      return {
        ...BASE_CONFIG,
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0.1,

        integrations: [
          Sentry.replayIntegration({
            maskAllText: true,
            // Only sample replays for exceptions containing specific error messages
            beforeErrorSampling: (event) =>
              Boolean(
                event.exception &&
                  event.exception.values?.some(
                    (exception) =>
                      exception.value &&
                      REPLAY_ERROR_FILTER.some((errorFilter) => exception.value?.includes(errorFilter)),
                  ),
              ),
          }),
        ],
      };
  }
};
